var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { computed, watch, ref, onMounted, onUnmounted, defineComponent, inject, toRef, createVNode, reactive, provide, h } from "vue";
import { useState } from "vue3-normal-library";
function initState(props, emit) {
  const [width, setWidthFunc] = useState(props.initW);
  const [height, setHeightFunc] = useState(props.initH);
  const [left, setLeftFunc] = useState(props.x);
  const [top, setTopFunc] = useState(props.y);
  const [zIndex, setZIndex] = useState(props.z);
  const [rotate, setRotate] = useState(props.r);
  const [enable, setEnable] = useState(props.active);
  const [rotating, setRotating] = useState(false);
  const [dragging, setDragging] = useState(false);
  const [resizing, setResizing] = useState(false);
  const [resizingHandle, setResizingHandle] = useState("");
  const [resizingMaxWidth, setResizingMaxWidth] = useState(Infinity);
  const [resizingMaxHeight, setResizingMaxHeight] = useState(Infinity);
  const [resizingMinWidth, setResizingMinWidth] = useState(props.minW);
  const [resizingMinHeight, setResizingMinHeight] = useState(props.minH);
  const aspectRatio = computed(() => height.value / width.value);
  watch(width, (newVal) => {
    emit("update:w", newVal);
  }, { immediate: true });
  watch(height, (newVal) => {
    emit("update:h", newVal);
  }, { immediate: true });
  watch(rotate, (newVal) => {
    emit("update:r", newVal || 0);
  }, { immediate: true });
  watch(top, (newVal) => {
    emit("update:y", newVal);
  });
  watch(left, (newVal) => {
    emit("update:x", newVal);
  });
  watch(enable, (newVal, oldVal) => {
    emit("update:active", newVal);
    if (!oldVal && newVal) {
      emit("activated");
    } else if (oldVal && !newVal) {
      emit("deactivated");
    }
  });
  watch(() => props.active, (newVal) => {
    setEnable(newVal);
  });
  return {
    id: getId(),
    width,
    height,
    top,
    left,
    zIndex,
    rotate,
    enable,
    dragging,
    resizing,
    rotating,
    resizingHandle,
    resizingMaxHeight,
    resizingMaxWidth,
    resizingMinWidth,
    resizingMinHeight,
    aspectRatio,
    setEnable,
    setDragging,
    setResizing,
    setRotating,
    setResizingHandle,
    setResizingMaxHeight,
    setResizingMaxWidth,
    setResizingMinWidth,
    setResizingMinHeight,
    setRotate,
    setZIndex,
    setWidth: (val) => setWidthFunc(Math.floor(val)),
    setHeight: (val) => setHeightFunc(Math.floor(val)),
    setTop: (val) => setTopFunc(Math.floor(val)),
    setLeft: (val) => setLeftFunc(Math.floor(val))
  };
}
function initParent(containerRef) {
  const parentWidth = ref(0);
  const parentHeight = ref(0);
  onMounted(() => {
    if (containerRef.value && containerRef.value.parentElement) {
      const { width, height } = getElSize(containerRef.value.parentElement);
      parentWidth.value = width;
      parentHeight.value = height;
    }
  });
  return {
    parentWidth,
    parentHeight
  };
}
function initLimitSizeAndMethods(props, parentSize, containerProps) {
  const {
    width,
    height,
    left,
    top,
    rotate,
    resizingMaxWidth,
    resizingMaxHeight,
    resizingMinWidth,
    resizingMinHeight
  } = containerProps;
  const { setWidth, setHeight, setTop, setLeft, setRotate } = containerProps;
  const { parentWidth, parentHeight } = parentSize;
  const limitProps = {
    minWidth: computed(() => {
      return resizingMinWidth.value;
    }),
    minHeight: computed(() => {
      return resizingMinHeight.value;
    }),
    maxWidth: computed(() => {
      let max = Infinity;
      if (props.parent) {
        max = Math.min(parentWidth.value, resizingMaxWidth.value);
      }
      return max;
    }),
    maxHeight: computed(() => {
      let max = Infinity;
      if (props.parent) {
        max = Math.min(parentHeight.value, resizingMaxHeight.value);
      }
      return max;
    }),
    minLeft: computed(() => {
      return props.parent ? 0 : -Infinity;
    }),
    minTop: computed(() => {
      return props.parent ? 0 : -Infinity;
    }),
    maxLeft: computed(() => {
      return props.parent ? parentWidth.value - width.value : Infinity;
    }),
    maxTop: computed(() => {
      return props.parent ? parentHeight.value - height.value : Infinity;
    })
  };
  const limitMethods = {
    setWidth(val) {
      if (props.disabledW) {
        return width.value;
      }
      return setWidth(Math.min(limitProps.maxWidth.value, Math.max(limitProps.minWidth.value, val)));
    },
    setHeight(val) {
      if (props.disabledH) {
        return height.value;
      }
      return setHeight(Math.min(limitProps.maxHeight.value, Math.max(limitProps.minHeight.value, val)));
    },
    setTop(val) {
      if (props.disabledY) {
        return top.value;
      }
      return setTop(Math.min(limitProps.maxTop.value, Math.max(limitProps.minTop.value, val)));
    },
    setLeft(val) {
      if (props.disabledX) {
        return left.value;
      }
      return setLeft(Math.min(limitProps.maxLeft.value, Math.max(limitProps.minLeft.value, val)));
    },
    setRotate(val) {
      if (!props.rotatable) {
        return rotate.value;
      }
      return setRotate(val || 0);
    }
  };
  return __spreadValues(__spreadValues({}, limitProps), limitMethods);
}
const DOWN_HANDLES = ["mousedown", "touchstart"];
const UP_HANDLES = ["mouseup", "touchend"];
const MOVE_HANDLES = ["mousemove", "touchmove"];
function getPosition(e) {
  if ("touches" in e) {
    return [e.touches[0].pageX, e.touches[0].pageY];
  } else {
    return [e.pageX, e.pageY];
  }
}
function initDraggableContainer(containerRef, containerProps, limitProps, draggable, emit, containerProvider, parentSize) {
  const { left: x, top: y, width: w, height: h2, dragging, id, rotate: r } = containerProps;
  const { setDragging, setEnable, setResizing, setResizingHandle } = containerProps;
  const { setTop, setLeft } = limitProps;
  let lstX = 0;
  let lstY = 0;
  let lstPageX = 0;
  let lstPageY = 0;
  let referenceLineMap = null;
  const documentElement = document.documentElement;
  const _unselect = (e) => {
    var _a;
    const target = e.target;
    if (!((_a = containerRef.value) == null ? void 0 : _a.contains(target))) {
      setEnable(false);
      setDragging(false);
      setResizing(false);
      setResizingHandle("");
    }
  };
  const handleUp = () => {
    setDragging(false);
    removeEvent(documentElement, UP_HANDLES, handleUp);
    removeEvent(documentElement, MOVE_HANDLES, handleDrag);
    referenceLineMap = null;
    if (containerProvider) {
      containerProvider.updatePosition(id, {
        x: x.value,
        y: y.value,
        w: w.value,
        h: h2.value,
        r: r.value
      });
      containerProvider.setMatchedLine(null);
    }
  };
  const handleDrag = (e) => {
    e.preventDefault();
    if (!(dragging.value && containerRef.value))
      return;
    const [pageX, pageY] = getPosition(e);
    const deltaX = pageX - lstPageX;
    const deltaY = pageY - lstPageY;
    let newLeft = lstX + deltaX;
    let newTop = lstY + deltaY;
    if (referenceLineMap !== null) {
      const widgetSelfLine = {
        col: [newLeft, newLeft + w.value / 2, newLeft + w.value],
        row: [newTop, newTop + h2.value / 2, newTop + h2.value]
      };
      const matchedLine = {
        row: widgetSelfLine.row.map((i, index2) => {
          let match = null;
          Object.values(referenceLineMap.row).forEach((referItem) => {
            if (i >= referItem.min && i <= referItem.max) {
              match = referItem.value;
            }
          });
          if (match !== null) {
            if (index2 === 0) {
              newTop = match;
            } else if (index2 === 1) {
              newTop = Math.floor(match - h2.value / 2);
            } else if (index2 === 2) {
              newTop = Math.floor(match - h2.value);
            }
          }
          return match;
        }).filter((i) => i !== null),
        col: widgetSelfLine.col.map((i, index2) => {
          let match = null;
          Object.values(referenceLineMap.col).forEach((referItem) => {
            if (i >= referItem.min && i <= referItem.max) {
              match = referItem.value;
            }
          });
          if (match !== null) {
            if (index2 === 0) {
              newLeft = match;
            } else if (index2 === 1) {
              newLeft = Math.floor(match - w.value / 2);
            } else if (index2 === 2) {
              newLeft = Math.floor(match - w.value);
            }
          }
          return match;
        }).filter((i) => i !== null)
      };
      containerProvider.setMatchedLine(matchedLine);
    }
    emit("dragging", { x: setLeft(newLeft), y: setTop(newTop) });
  };
  const handleDown = (e) => {
    if (!draggable.value)
      return;
    setDragging(true);
    lstX = x.value;
    lstY = y.value;
    lstPageX = getPosition(e)[0];
    lstPageY = getPosition(e)[1];
    addEvent(documentElement, MOVE_HANDLES, handleDrag);
    addEvent(documentElement, UP_HANDLES, handleUp);
    if (containerProvider && !containerProvider.disabled.value) {
      referenceLineMap = getReferenceLineMap(containerProvider, parentSize, id);
    }
  };
  watch(dragging, (cur, pre) => {
    if (!pre && cur) {
      emit("drag-start", { x: x.value, y: y.value });
      setEnable(true);
      setDragging(true);
    } else {
      emit("drag-end", { x: x.value, y: y.value });
      setDragging(false);
    }
  });
  onMounted(() => {
    const el = containerRef.value;
    if (!el)
      return;
    el.style.left = x + "px";
    el.style.top = y + "px";
    addEvent(documentElement, DOWN_HANDLES, _unselect);
    addEvent(el, DOWN_HANDLES, handleDown);
  });
  onUnmounted(() => {
    if (!containerRef.value)
      return;
    removeEvent(documentElement, DOWN_HANDLES, _unselect);
    removeEvent(documentElement, UP_HANDLES, handleUp);
    removeEvent(documentElement, MOVE_HANDLES, handleDrag);
  });
  return { containerRef };
}
function initResizeHandle(containerProps, limitProps, parentSize, props, emit) {
  const { setWidth, setHeight, setLeft, setTop } = limitProps;
  const { width, height, left, top, aspectRatio } = containerProps;
  const {
    setResizing,
    setResizingHandle,
    setResizingMaxWidth,
    setResizingMaxHeight,
    setResizingMinWidth,
    setResizingMinHeight
  } = containerProps;
  const { parentWidth, parentHeight } = parentSize;
  let lstW = 0;
  let lstH = 0;
  let lstX = 0;
  let lstY = 0;
  let lstPageX = 0;
  let lstPageY = 0;
  let tmpAspectRatio = 1;
  let idx0 = "";
  let idx1 = "";
  const documentElement = document.documentElement;
  const resizeHandleDrag = (e) => {
    e.preventDefault();
    const [_pageX, _pageY] = getPosition(e);
    let deltaX = _pageX - lstPageX;
    let deltaY = _pageY - lstPageY;
    const _deltaX = deltaX;
    const _deltaY = deltaY;
    if (props.lockAspectRatio) {
      deltaX = Math.abs(deltaX);
      deltaY = deltaX * tmpAspectRatio;
      if (idx0 === "t") {
        if (_deltaX < 0 || idx1 === "m" && _deltaY < 0) {
          deltaX = -deltaX;
          deltaY = -deltaY;
        }
      } else {
        if (_deltaX < 0 || idx1 === "m" && _deltaY < 0) {
          deltaX = -deltaX;
          deltaY = -deltaY;
        }
      }
    }
    if (idx0 === "t") {
      setHeight(lstH - deltaY);
      setTop(lstY - (height.value - lstH));
    } else if (idx0 === "b") {
      setHeight(lstH + deltaY);
    }
    if (idx1 === "l") {
      setWidth(lstW - deltaX);
      setLeft(lstX - (width.value - lstW));
    } else if (idx1 === "r") {
      setWidth(lstW + deltaX);
    }
    emit("resizing", {
      x: left.value,
      y: top.value,
      w: width.value,
      h: height.value
    });
  };
  const resizeHandleUp = () => {
    emit("resize-end", {
      x: left.value,
      y: top.value,
      w: width.value,
      h: height.value
    });
    setResizingHandle("");
    setResizing(false);
    setResizingMaxWidth(Infinity);
    setResizingMaxHeight(Infinity);
    setResizingMinWidth(props.minW);
    setResizingMinHeight(props.minH);
    removeEvent(documentElement, MOVE_HANDLES, resizeHandleDrag);
    removeEvent(documentElement, UP_HANDLES, resizeHandleUp);
  };
  const resizeHandleDown = (e, handleType) => {
    if (!props.resizable)
      return;
    e.stopPropagation();
    setResizingHandle(handleType);
    setResizing(true);
    idx0 = handleType[0];
    idx1 = handleType[1];
    if (aspectRatio.value) {
      if (["tl", "tm", "ml", "bl"].includes(handleType)) {
        idx0 = "t";
        idx1 = "l";
      } else {
        idx0 = "b";
        idx1 = "r";
      }
    }
    let minHeight = props.minH;
    let minWidth = props.minW;
    if (minHeight / minWidth > aspectRatio.value) {
      minWidth = minHeight / aspectRatio.value;
    } else {
      minHeight = minWidth * aspectRatio.value;
    }
    setResizingMinWidth(minWidth);
    setResizingMinHeight(minHeight);
    if (parent) {
      let maxHeight = idx0 === "t" ? top.value + height.value : parentHeight.value - top.value;
      let maxWidth = idx1 === "l" ? left.value + width.value : parentWidth.value - left.value;
      if (props.lockAspectRatio) {
        if (maxHeight / maxWidth < aspectRatio.value) {
          maxWidth = maxHeight / aspectRatio.value;
        } else {
          maxHeight = maxWidth * aspectRatio.value;
        }
      }
      setResizingMaxHeight(maxHeight);
      setResizingMaxWidth(maxWidth);
    }
    lstW = width.value;
    lstH = height.value;
    lstX = left.value;
    lstY = top.value;
    const lstPagePosition = getPosition(e);
    lstPageX = lstPagePosition[0];
    lstPageY = lstPagePosition[1];
    tmpAspectRatio = aspectRatio.value;
    emit("resize-start", {
      x: left.value,
      y: top.value,
      w: width.value,
      h: height.value
    });
    addEvent(documentElement, MOVE_HANDLES, resizeHandleDrag);
    addEvent(documentElement, UP_HANDLES, resizeHandleUp);
  };
  onUnmounted(() => {
    removeEvent(documentElement, UP_HANDLES, resizeHandleUp);
    removeEvent(documentElement, MOVE_HANDLES, resizeHandleDrag);
  });
  const handlesFiltered = computed(() => props.resizable ? filterHandles(props.handles) : []);
  return {
    handlesFiltered,
    resizeHandleDown
  };
}
function watchProps(props, limits) {
  const { setWidth, setHeight, setLeft, setTop, setRotate } = limits;
  watch(() => props.w, (newVal) => {
    setWidth(newVal);
  });
  watch(() => props.h, (newVal) => {
    setHeight(newVal);
  });
  watch(() => props.x, (newVal) => {
    setLeft(newVal);
  });
  watch(() => props.y, (newVal) => {
    setTop(newVal);
  });
  watch(() => props.r, (newVal) => {
    setRotate(newVal);
  });
}
function initRotateContainer(containerRef, containerProps, props, emit) {
  const { setRotating, setRotate, rotate } = containerProps;
  const documentElement = document.documentElement;
  const rotateHandleDrag = (e) => {
    e.preventDefault();
    if (!containerRef.value)
      return;
    const angle = calcAngle(containerRef.value, e) % 360;
    setRotate(angle);
    emit("rotating", rotate.value);
  };
  const rotateHandleUp = () => {
    if (!containerRef.value)
      return;
    setRotating(false);
    emit("rotate-end", rotate.value);
    removeEvent(documentElement, MOVE_HANDLES, rotateHandleDrag);
    removeEvent(documentElement, UP_HANDLES, rotateHandleUp);
  };
  const rotateHandle = (e) => {
    if (!props.rotatable)
      return;
    e.stopPropagation();
    if (!containerRef.value)
      return;
    setRotating(true);
    emit("rotate-start", rotate.value);
    addEvent(documentElement, MOVE_HANDLES, rotateHandleDrag);
    addEvent(documentElement, UP_HANDLES, rotateHandleUp);
  };
  onUnmounted(() => {
    removeEvent(documentElement, UP_HANDLES, rotateHandleDrag);
    removeEvent(documentElement, MOVE_HANDLES, rotateHandleUp);
  });
  return { rotateHandle };
}
var index = "";
const ALL_HANDLES = ["tl", "tm", "tr", "ml", "mr", "bl", "bm", "br"];
const VdrProps = {
  initW: {
    type: Number,
    default: null
  },
  initH: {
    type: Number,
    default: null
  },
  w: {
    type: Number,
    default: 0
  },
  h: {
    type: Number,
    default: 0
  },
  x: {
    type: Number,
    default: 0
  },
  y: {
    type: Number,
    default: 0
  },
  z: {
    type: Number,
    default: 0
  },
  r: {
    type: Number,
    default: 0
  },
  rotatable: {
    type: Boolean,
    default: true
  },
  draggable: {
    type: Boolean,
    default: true
  },
  resizable: {
    type: Boolean,
    default: true
  },
  disabledX: {
    type: Boolean,
    default: false
  },
  disabledY: {
    type: Boolean,
    default: false
  },
  disabledW: {
    type: Boolean,
    default: false
  },
  disabledH: {
    type: Boolean,
    default: false
  },
  minW: {
    type: Number,
    default: 20
  },
  minH: {
    type: Number,
    default: 20
  },
  active: {
    type: Boolean,
    default: false
  },
  parent: {
    type: Boolean,
    default: false
  },
  handles: {
    type: Array,
    default: ALL_HANDLES,
    validator: (handles) => {
      return filterHandles(handles).length === handles.length;
    }
  },
  classNameDraggable: {
    type: String,
    default: "draggable"
  },
  classNameResizable: {
    type: String,
    default: "resizable"
  },
  classNameDragging: {
    type: String,
    default: "dragging"
  },
  classNameResizing: {
    type: String,
    default: "resizing"
  },
  classNameActive: {
    type: String,
    default: "active"
  },
  classNameHandle: {
    type: String,
    default: "handle"
  },
  classNameRotator: {
    type: String,
    default: "rotator"
  },
  lockAspectRatio: {
    type: Boolean,
    default: false
  }
};
const emits = ["activated", "deactivated", "drag-start", "resize-start", "dragging", "resizing", "drag-end", "rotating", "rotate-start", "rotate-end", "resize-end", "update:w", "update:h", "update:x", "update:y", "update:r", "update:active"];
const VueDraggableResizable = defineComponent({
  name: "DraggableResizer",
  props: VdrProps,
  emits,
  setup(props, {
    emit
  }) {
    const containerProps = initState(props, emit);
    const provideIdentity = inject("identity");
    let containerProvider = null;
    if (provideIdentity === IDENTITY) {
      containerProvider = {
        updatePosition: inject("updatePosition"),
        getPositionStore: inject("getPositionStore"),
        disabled: inject("disabled"),
        adsorbParent: inject("adsorbParent"),
        adsorbCols: inject("adsorbCols"),
        adsorbRows: inject("adsorbRows"),
        setMatchedLine: inject("setMatchedLine")
      };
    }
    const containerRef = ref();
    const parentSize = initParent(containerRef);
    const limitProps = initLimitSizeAndMethods(props, parentSize, containerProps);
    initDraggableContainer(containerRef, containerProps, limitProps, toRef(props, "draggable"), emit, containerProvider, parentSize);
    const resizeHandle = initResizeHandle(containerProps, limitProps, parentSize, props, emit);
    const rotateHandle = initRotateContainer(containerRef, containerProps, props, emit);
    watchProps(props, limitProps);
    return __spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues({
      containerRef,
      containerProvider
    }, containerProps), parentSize), limitProps), resizeHandle), rotateHandle);
  },
  computed: {
    style() {
      return {
        width: this.width + "px",
        height: this.height + "px",
        top: this.top + "px",
        left: this.left + "px",
        zIndex: this.zIndex,
        transform: `rotate(${this.rotate}deg)`
      };
    },
    klass() {
      return {
        [this.classNameActive]: this.enable,
        [this.classNameDragging]: this.dragging,
        [this.classNameResizing]: this.resizing,
        [this.classNameDraggable]: this.draggable,
        [this.classNameResizable]: this.resizable
      };
    }
  },
  mounted() {
    if (!this.containerRef)
      return;
    this.containerRef.ondragstart = () => false;
    const {
      width,
      height
    } = getElSize(this.containerRef);
    this.setWidth(this.initW === null ? this.w || width : this.initW);
    this.setHeight(this.initH === null ? this.h || height : this.initH);
    if (this.containerProvider) {
      this.containerProvider.updatePosition(this.id, {
        x: this.left,
        y: this.top,
        w: this.width,
        h: this.height,
        r: this.rotate
      });
    }
  },
  render() {
    const handlers = this.handlesFiltered.map((item) => {
      const handleClass = ["vdr-handle", "vdr-handle-" + item, this.classNameHandle, `${this.classNameHandle}-${item}`];
      return createVNode("div", {
        "class": handleClass,
        "onMousedown": (e) => this.resizeHandleDown(e, item),
        "onTouchstart": (e) => this.resizeHandleDown(e, item)
      }, null);
    });
    return createVNode("div", {
      "ref": "containerRef",
      "class": ["vdr-container", this.klass],
      "style": this.style
    }, [this.$slots.default && this.$slots.default(), this.enable && handlers, this.rotatable && this.enable && createVNode("div", {
      "class": ["vdr-rotator", this.classNameRotator],
      "onMousedown": (e) => this.rotateHandle(e),
      "onTouchstart": (e) => this.rotateHandle(e)
    }, null)]);
  }
});
const IDENTITY = Symbol("DraggableResizable");
function getElSize(el) {
  const style = window.getComputedStyle(el);
  return {
    width: parseFloat(style.getPropertyValue("width")),
    height: parseFloat(style.getPropertyValue("height"))
  };
}
function createEventListenerFunction(type) {
  return (el, events, handler) => {
    if (!el) {
      return;
    }
    if (typeof events === "string") {
      events = [events];
    }
    events.forEach((e) => el[type](e, handler, { passive: false }));
  };
}
const addEvent = createEventListenerFunction("addEventListener");
const removeEvent = createEventListenerFunction("removeEventListener");
function filterHandles(handles) {
  if (handles && handles.length > 0) {
    const result = [];
    handles.forEach((item) => {
      if (ALL_HANDLES.includes(item) && !result.includes(item)) {
        result.push(item);
      }
    });
    return result;
  } else {
    return [];
  }
}
function getId() {
  return String(Math.random()).substr(2) + String(Date.now());
}
function getReferenceLineMap(containerProvider, parentSize, id) {
  if (containerProvider.disabled.value) {
    return null;
  }
  const referenceLine = {
    row: [],
    col: []
  };
  const { parentWidth, parentHeight } = parentSize;
  referenceLine.row.push(...containerProvider.adsorbRows);
  referenceLine.col.push(...containerProvider.adsorbCols);
  if (containerProvider.adsorbParent.value) {
    referenceLine.row.push(0, parentHeight.value, parentHeight.value / 2);
    referenceLine.col.push(0, parentWidth.value, parentWidth.value / 2);
  }
  const widgetPositionStore = containerProvider.getPositionStore(id);
  Object.values(widgetPositionStore).forEach(({ x, y, w, h: h2 }) => {
    referenceLine.row.push(y, y + h2, y + h2 / 2);
    referenceLine.col.push(x, x + w, x + w / 2);
  });
  const referenceLineMap = {
    row: referenceLine.row.reduce((pre, cur) => {
      return __spreadProps(__spreadValues({}, pre), { [cur]: { min: cur - 5, max: cur + 5, value: cur } });
    }, {}),
    col: referenceLine.col.reduce((pre, cur) => {
      return __spreadProps(__spreadValues({}, pre), { [cur]: { min: cur - 5, max: cur + 5, value: cur } });
    }, {})
  };
  return referenceLineMap;
}
function calcAngle(element, event) {
  const rect = element.getBoundingClientRect();
  const originX = rect.left + rect.width / 2;
  const originY = rect.top + rect.height / 2;
  const clientX = "touches" in event ? event.touches[0].clientX : event.clientX;
  const clientY = "touches" in event ? event.touches[0].clientY : event.clientY;
  const x = Math.abs(originX - clientX);
  const y = Math.abs(originY - clientY);
  const z = Math.sqrt(Math.pow(x, 2) + Math.pow(y, 2));
  const cos = y / z;
  const rad = Math.acos(cos);
  let angle = Math.floor(180 / (Math.PI / rad));
  if (clientX > originX && clientY > originY) {
    angle = 180 - angle;
  }
  if (clientX == originX && clientY > originY) {
    angle = 180;
  }
  if (clientX > originX && clientY == originY) {
    angle = 90;
  }
  if (clientX < originX && clientY > originY) {
    angle = 180 + angle;
  }
  if (clientX < originX && clientY == originY) {
    angle = 270;
  }
  if (clientX < originX && clientY < originY) {
    angle = 360 - angle;
  }
  return angle;
}
var DraggableContainer = defineComponent({
  name: "DraggableContainer",
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    adsorbParent: {
      type: Boolean,
      default: true
    },
    adsorbCols: {
      type: Array,
      default: null
    },
    adsorbRows: {
      type: Array,
      default: null
    },
    referenceLineVisible: {
      type: Boolean,
      default: true
    },
    referenceLineColor: {
      type: String,
      default: "#5386df"
    }
  },
  setup(props) {
    const positionStore = reactive({});
    const updatePosition = (id, position) => {
      positionStore[id] = position;
    };
    const getPositionStore = (excludeId) => {
      const _positionStore = Object.assign({}, positionStore);
      if (excludeId) {
        delete _positionStore[excludeId];
      }
      return _positionStore;
    };
    const state = reactive({
      matchedLine: null
    });
    const matchedRows = computed(() => state.matchedLine && state.matchedLine.row || []);
    const matchedCols = computed(() => state.matchedLine && state.matchedLine.col || []);
    const setMatchedLine = (matchedLine) => {
      state.matchedLine = matchedLine;
    };
    provide("identity", IDENTITY);
    provide("updatePosition", updatePosition);
    provide("getPositionStore", getPositionStore);
    provide("setMatchedLine", setMatchedLine);
    provide("disabled", toRef(props, "disabled"));
    provide("adsorbParent", toRef(props, "adsorbParent"));
    provide("adsorbCols", props.adsorbCols || []);
    provide("adsorbRows", props.adsorbRows || []);
    return {
      matchedRows,
      matchedCols
    };
  },
  methods: {
    renderReferenceLine() {
      if (!this.referenceLineVisible) {
        return [];
      }
      return [
        ...this.matchedCols.map((item) => {
          return h("div", {
            style: {
              width: "0",
              height: "100%",
              top: "0",
              left: item + "px",
              borderLeft: `1px dashed ${this.referenceLineColor}`,
              position: "absolute"
            }
          });
        }),
        ...this.matchedRows.map((item) => {
          return h("div", {
            style: {
              width: "100%",
              height: "0",
              left: "0",
              top: item + "px",
              borderTop: `1px dashed ${this.referenceLineColor}`,
              position: "absolute"
            }
          });
        })
      ];
    }
  },
  render() {
    return h("div", {
      style: { width: "100%", height: "100%", position: "relative" }
    }, [this.$slots.default && this.$slots.default(), ...this.renderReferenceLine()]);
  }
});
export { DraggableContainer, VueDraggableResizable as DraggableResizer };
